import React, { useEffect } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function UserProductSalesCard({ userData }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Row>
          <Col>
            <Card.Title as="h4" style={{ color: userData.color }}>{`${userData.username}`}</Card.Title>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              <th>{t("tables.headers.product")}</th>
              <th className="align-text-right">{t("tables.headers.qty")}</th>
              <th className="align-text-right">{t("tables.headers.totalEuro")}</th>
            </tr>
          </thead>
          <tbody>
            {userData.products.map((row) => (
              <tr key={row.product_id}>
                <td>{row.product_name}</td>
                <td className="align-text-right">{row.quantity}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr>
              <td className="bold">{t("summaries.total")}</td>
              <td className="bold align-text-right">{userData.quantity.toFixed(0)}</td>
              <td className="bold align-text-right">{userData.total.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default UserProductSalesCard;
